import React, { ReactElement, useEffect } from 'react';

import { Icon } from 'leeloo-react/component/display/Icon';
import { useDataSource } from 'leeloo-react/component/hook/useDataSource';

import { ResourceDataProviderEnum } from '../../../../enum/ResourceDataProviderEnum';
import { KpiType } from '../../../../model/kpis/KpiType';
import { ThemeStatsType } from '../../../../model/kpis/ThemeStatsType';
import Barchart from '../../../chart/Barchart';
import { RouterCustomFileLink } from '../../../router/RouterCustomFileLink';

type KpiThematiqueELearningByAgencyProps = {
  dateRange: KpiType['dateRange'];
  agency: string;
}

export function KpiThematiqueELearningByAgency({ dateRange, agency }: KpiThematiqueELearningByAgencyProps): ReactElement {
  const dsThematics = useDataSource<ThemeStatsType[]>({
    resource: ResourceDataProviderEnum.kpisManagerELearningThematicsByAgency,
    singleResult: true,
    noLoadAfterInit: true,
  });

  useEffect(() => {
    if (dateRange && agency) {
      const params = {
        uriParameters: {
          startAt: dateRange?.startAt || null,
          endAt: dateRange?.endAt || null,
          agency: agency || null,
        },
      };

      dsThematics.setParams(params);
    }
  }, [dateRange, agency]);

  return (
    <div className="p-3 bg-dark-grey mb-4">
      <div className="d-flex justify-content-between">
        <h4>Formations E-Learning</h4>
        <RouterCustomFileLink
          resource={ResourceDataProviderEnum.kpisManagerELearningThematicsByAgencyExport}
          params={{
            data: {
              startAt: dateRange?.startAt || null,
              endAt: dateRange?.endAt || null,
              agency: agency || null,
            },
          }}
          nameFile="dashboard_theme.csv"
          className="btn btn-outline-primary square"
        >
          <Icon name="uil uil-export" />
        </RouterCustomFileLink>
      </div>
      <Barchart
        label="Formations"
        backgroundColor={['#9500FF']}
        labels={dsThematics?.oneData?.map((value) => value.name) ?? []}
        data={dsThematics?.oneData?.map((value) => value.nbrFormation) ?? []}
      />
    </div>
  );
}
